import { Clock, Eye, Send, FileCheck, Palette, FlaskConical, CheckCircle2, XCircle } from "lucide-react";

const CONFIG = {
  ready_for_submission: [Clock, "Ready for Submission", "status-new_project"],
  artwork_submitted: [Send, "Artwork Submitted", "status-artwork_submitted"],
  pdf_proof: [FileCheck, "PDF Proof", "status-pdf_proof_phase"],
  swatch: [Palette, "Swatch", "status-swatch_drawdown_phase"],
  pilot: [FlaskConical, "Pilot", "status-pilot_proof_phase"],
  graphics_complete: [CheckCircle2, "Graphics Complete", "status-graphics_completed"],
  new_project: [Clock, "New Project", "status-new_project"],
  graphic_team_review: [Eye, "Graphic Team Review", "status-graphic_team_review"],
  pdf_proof_phase: [FileCheck, "PDF Proof Phase", "status-pdf_proof_phase"],
  swatch_drawdown_phase: [Palette, "Swatch Drawdown", "status-swatch_drawdown_phase"],
  pilot_proof_phase: [FlaskConical, "Pilot Proof Phase", "status-pilot_proof_phase"],
  graphics_completed: [CheckCircle2, "Graphics Completed", "status-graphics_completed"],
  pending: [Clock, "New Project", "status-new_project"],
  in_progress: [Eye, "In Progress", "status-graphic_team_review"],
  review: [Send, "In Review", "status-artwork_submitted"],
  approved: [CheckCircle2, "Completed", "status-graphics_completed"],
  rejected: [XCircle, "Rejected", "status-rejected"],
};

export const StatusBadge = ({ status }) => {
  const [Icon, label, cls] = CONFIG[status] || CONFIG.new_project;
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold border ${cls}`}><Icon size={12} />{label}</span>;
};

export const PriorityBadge = ({ priority }) => <span className={`text-xs font-medium capitalize priority-${priority}`}>{priority}</span>;

export const FileTypeBadge = ({ type }) => {
  const normalizedType = type?.toLowerCase() || "file";
  return <span className={`file-badge file-badge-${normalizedType}`}>{type}</span>;
};
